// extracted by mini-css-extract-plugin
export default {"inputContainer":"_508647f3","header":"_7b8d48dd","description":"_85ed7cc4","placeholder":"_b3ff6f01","modalButtonContainer":"_4c3f6218","modalButton":"_35c8119f"};